import React from 'react';
import { Alert, Button } from 'antd';
import { useDispatch, useIntl } from 'umi';
import { ContactModel } from '@/typings/models/Contact';
import { CONTACT_ENTITY, getContactCustomerId } from '@/utils/contacts';
import { F, getIntlTranslation, INTL_ACTION } from '@/utils/intl';
import DuplicateElsewhereText from './DuplicateElsewhereText';
import type { PartnerDuplicate } from './usePartnerDuplicateContact';

/**
 * Heads-up that another customer's contact already uses this email or phone:
 * with `onLink`, the way to add that person here instead of a duplicate, else
 * a way to look at them.
 */
const DuplicateElsewhereNotice: React.FC<{
  duplicate: NonNullable<PartnerDuplicate>;
  onLink?: (contact: ContactModel) => void;
  className?: string;
}> = ({ duplicate, onLink, className }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  return (
    <Alert
      type="info"
      className={className}
      title={
        <span>
          <DuplicateElsewhereText duplicate={duplicate} />{' '}
          {onLink ? (
            <Button type="link" size="small" onClick={() => onLink(duplicate.contact)}>
              <F id="component.contacts.linkInstead" defaultMessage="Link instead" />
            </Button>
          ) : (
            <Button
              type="link"
              size="small"
              onClick={() =>
                dispatch({
                  type: 'contacts/openDrawer',
                  payload: { contactId: duplicate.contact.id, customerId: getContactCustomerId(duplicate.contact) },
                })
              }
            >
              {getIntlTranslation(intl, { entity: CONTACT_ENTITY, action: INTL_ACTION.VIEW })}
            </Button>
          )}
        </span>
      }
    />
  );
};

export default React.memo(DuplicateElsewhereNotice);
